import { Loader2 } from 'lucide-react';

export default function Loader() {
    return (
        <div className="flex h-screen items-center justify-center">
            <Loader2 className="h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-primary text-primary" />
        </div>
    );
}
